












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
  name: 'Toast',
})
export default class Toast extends Vue {
  @Prop({required: true}) message!: string;
  @Prop({default: 3000}) duration!: number;
  @Prop({default: false}) isOpen!: boolean;

  @Watch('isOpen')
  onIsOpenChanged(newVal: boolean) {
    if (newVal === true) {
      this.openToast();
    }
  }

  beforeMount() {
    let container = document.querySelector('.toast-container') as HTMLElement | null;
    if (!container) {
      container = document.createElement('div');
      container.className = 'toast-container';
      document.body.appendChild(container);
    }
  }
 openToast() {
    this.$emit('toast-triggered')
    let toast: HTMLElement = document.createElement('div');
    toast = this.$el.cloneNode(true) as HTMLElement;
    toast.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

      toast.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeToast(toast.id);
      });

    let container = document.querySelector('.toast-container') as HTMLElement | null;
    if (!container) return;

    container.appendChild(toast);
    toast.classList.add('toast--fadeIn');

    setTimeout(() => {
      this.closeToast(toast.id);
    }, this.duration)

  }

  closeToast(id: string) {
    const toast = document.getElementById(id) as HTMLElement | null;
    if (!toast) return;
    toast.classList.add('toast--fadeOut');
    setTimeout(() => {
      toast.remove();
    }, 500);
  }
}

